var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTablet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25,12V68A2.7528,2.7528,0,0,0,20,70.75H60A2.7528,2.7528,0,0,0,62.75,68V12A2.7528,2.7528,0,0,0,60,9.25H20A2.7528,2.7528,0,0,0,17.25,12Zm1.5,0A1.25116,1.25116,0,0,1,20,10.75H60A1.25116,1.25116,0,0,1,61.25,12V68A1.25116,1.25116,0,0,1,60,69.25H20A1.25116,1.25116,0,0,1,18.75,68Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 15.25,
    width: 6,
    height: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40,61.25A2.75,2.75,0,1,0,42.75,64,2.7528,2.7528,0,0,0,40,61.25Zm0,4A1.25,1.25,0,1,1,41.25,64,1.25116,1.25116,0,0,1,40,65.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTablet);
export default __webpack_public_path__ + "static/media/icon_tablet.7054f7099a7462782360f50a9baf7a52.svg";
export { ForwardRef as ReactComponent };